module.exports = __webpack_public_path__ + "img/bb_g1_t_nose-05.7528cc4d.svg";